

function add_to_cart(id, inventory_quantity = 999, title = null) {
    /**
    @description: 
    @param {} 
    **/
    let warranty_select = document.getElementById("warranty"), 
        qty             = $('.input-number').val(), 
        expedited_chkbx = null; 
    
    // if (warranty_select && warranty_select.selectedIndex == 0) {
    //   swal('Missing Warranty\n',"Please select a valid warranty option", "warning");
    //     return; 
    // }

    
    let CartSession = CartManager('add', id, qty, inventory_quantity);
    console.log('CartSession:', CartSession);
    console.log('Adding to cart:', id, 'with quantity:', qty);
    if (CartSession[id].quantity > inventory_quantity) {
      swal({
        title: 'Quantity Exceeded',
        text: `You can only add up to ${inventory_quantity} of this item to your cart.`,
        icon: 'warning',
        buttons: {
          cancel: {
      text: "OK",
      value: null,
      visible: true,
      className: "swal-btn-cancel swal-btn-inline swal-btn-row1",
      closeModal: true,
          },
          rfq: {
      text: "Request a Quote",
      value: "rfq",
      visible: true,
      className: "swal-btn-confirm swal-btn-inline swal-btn-row1",
      closeModal: true,
          },
          checkout: {
      text: `Checkout with the ${inventory_quantity} items now`,
      value: "checkout",
      visible: true,
      className: "swal-btn-confirm swal-btn-block swal-btn-row2",
      closeModal: true,
          }
        }
      }).then(value => {
        if (value === "checkout") {
          window.location.href = '/checkout';
        }
        else if (value === "rfq") {
          window.location.href = '/pages/contact' + '?rfq=' + encodeURIComponent(title );
        }
      });


      setTimeout(() => {
        const swalFooter = document.querySelector('.swal-footer');
        if (swalFooter) {
          // Group row1 buttons
          const row1 = document.createElement('div');
          row1.style.display = 'flex';
          row1.style.justifyContent = 'center';
          row1.style.flexDirection = 'row-reverse';
          row1.style.gap = '8px';
          row1.className = 'swal-btn-row1-group';

          // Group row2 button
          const row2 = document.createElement('div');
          row2.style.marginTop = '12px';
          row2.style.display = 'flex';
          row2.style.justifyContent = 'center';
          row2.className = 'swal-btn-row2-group';

          swalFooter.style.display = 'flex';
          swalFooter.style.flexDirection = 'column-reverse';
          swalFooter.style.alignItems = 'center';
          swalFooter.style.justifyContent = 'center';

          // Move buttons into rows
          const btnContainers = swalFooter.querySelectorAll('.swal-button-container');
          btnContainers.forEach(container => {
          const btn = container.querySelector('button');
          if (btn && btn.classList.contains('swal-btn-row1')) {
            row1.appendChild(container);
          } else if (btn && btn.classList.contains('swal-btn-row2')) {
            row2.appendChild(container);
          }
            });

            // Clear footer and append rows
            swalFooter.innerHTML = '';
            swalFooter.appendChild(row1);
            swalFooter.appendChild(row2);
          }
        }, 10);

      return;
    }
  if ($(".custom_ip").val()) custom_os_ip         = $(".custom_ip").val().trim()
    if ($(".custom_remote").val()) custom_remote_ip = $(".custom_remote").val().trim(); 
  
    expedited_chkbx = document.getElementById("expedited-chkbx"); // expedidted shipping checkbox 
  
    if (expedited_chkbx !== null && expedited_chkbx.checked) cartAPI('POST', expedited, qty, [['Server SKU', prod_sku]]); 
    
    jQuery.getJSON('/cart.js', () => {
       cartAPI('POST', id, qty);
    });
    
    if (typeof custom_os_ip !== 'undefined' && custom_os_ip != '' ) cartAPI('POST', os_ip, qty, [['Server SKU', prod_sku], ['IP', custom_os_ip]])		
    if (typeof custom_remote_ip !== 'undefined' && custom_remote_ip != '' ) cartAPI('POST', remote_ip, qty, [['Server SKU', prod_sku], ['IP', custom_remote_ip]]); 
    added2CartModalMsg()

    UpdateCartCountInNav(qty);
  }

function UpdateCartCountInNav(qty = 1) {
    let CartCountInNav = document.getElementById('cartCount');
    let CurrentCount = 0;
    let AmntToAdd = parseInt(qty) || 1; 

    if (CartCountInNav) {
        CurrentCount = parseInt(CartCountInNav.innerText) || 0;
        CartCountInNav.innerText = CurrentCount + AmntToAdd;
    }
  }


function CartManager(fn = 'add', id = null, qty = 1, inventory_quantity = 999) {

  if (!id) return;
  if (qty <= 0) {
    console.error('Quantity must be greater than zero');
    return;
  }

  let CartSession = sessionStorage.getItem('cart') ? JSON.parse(sessionStorage.getItem('cart')) : {};

  if (fn === 'add') {
    if (!CartSession[id]) {
      if (qty <= inventory_quantity) {
        CartSession[id] = { quantity: 0, properties: {} };
      }
    }
    CartSession[id].quantity = parseInt(CartSession[id].quantity) + parseInt(qty);
  }
  else if (fn === 'remove') {
    if (CartSession[id]) {
      CartSession[id].quantity -= qty;
      if (CartSession[id].quantity <= 0) {
        delete CartSession[id];
      }
    }
  }
  else if (fn === 'update') {
    if (CartSession[id]) {
      CartSession[id].quantity = qty;
    }
  }

  sessionStorage.setItem('cart', JSON.stringify(CartSession));
  console.log('Cart updated:', CartSession);
  return CartSession;

}

function cartAPI(RESTtype, warranty_id=null, qty, args=[]) {
    /**
    @description: 
    @param {} 
    **/
    let data2Send = {
      id          : warranty_id,
      quantity    : qty,
      properties  : {}
    }
    
    for (var pair of args) {
      data2Send.properties[pair[0]] = pair[1]
    }
  
    $.ajax({
      type    : RESTtype,
      async   : false,
      url     : '/cart/add.js',
      data    : jQuery.param(data2Send),
      success : data => {
        console.log(data); 
        return; 
      },
      error   : data => {
        console.log(data); 
        return; 
      }
    });
}



function added2CartModalMsg(hardDrives=false) {
    /**
    @description: 
    @param {} 
    **/
    let msgObj = {
      title: "Added to Cart",
      icon: "success",
      buttons: {
        continueShopping: {
          text: "Continue Shopping",
          value: "shop",
          visible: true,
          className: "swal-btn-cancel",
          closeModal: true,
        },
        goCart: {
          text: "Go to Cart",
          value: "cart",
          visible: true,
          className: "swal-btn-confirm",
          closeModal: true,
        }
      }
    }
  
    if (hardDrives) {
      msgObj['text'] = "This hard drive does not include a caddy. Want to view our caddies now?"
      msgObj.buttons['viewCaddies'] = {
        text: "View Caddies",
        value: "view",
        visible: true,
        className: "swal-btn-confirm",
        closeModal: true,
      }
      swal(msgObj).then(value => {
        switch(value) {
          case "view":
            window.location.href = '/collections/caddies';
            break;
          case "cart":
            window.location.href = '/cart';
            break;
          case "default":
            break;
        }
      });
    } else {
      swal(msgObj).then( value => {
        switch (value) {
          case "cart":
            window.location.href = '/cart';
            break;
          case "default":
            break;
        }
      });
    }
}